import { Row } from '@global-engineering-shared/gweb-material-types';
import { useNavigate } from 'react-router';

import { ITableConfig } from 'components/Table/types/table';
import { useRefresh } from 'context/RefreshProvider/RefreshProvider';
import { useSearchParamsProvider } from 'context/SearchParamsProvider/SearchParamsProvider';
import EntitiesPageActionButtons from 'features/Entities/components/EntitiesPageActionButtons';
import { getEntityPageUrl } from 'features/Entity/utils/getEntityPageUrl';
import { TTableEntity } from 'types/tableEntityType';
import { ENTITY_API_URL, ENTITY_SEARCH_API_URL, SEARCH_TERM } from 'utils/defaults';

import useEntitiesTableColumns from './useEntitiesTableColumns';

export const useEntitiesTables = (): ITableConfig[] => {
  const navigate = useNavigate();
  const { refreshToggle } = useRefresh();
  const { searchParams } = useSearchParamsProvider();
  const searchTerm = searchParams.get(SEARCH_TERM);
  const url = searchTerm ? ENTITY_SEARCH_API_URL : ENTITY_API_URL;

  return [
    {
      hasCheckboxes: true,
      keyName: 'spaceId',
      columns: useEntitiesTableColumns(),
      tableItemGridTemplate: '40px 40px 120px 1fr 200px 200px 150px 120px',
      url,
      secondaryFooterComponents: [<EntitiesPageActionButtons />],
      handleRowClick: (row: Row<TTableEntity>) =>
        navigate(`${getEntityPageUrl(row.original.entityType)}/${row.original.spaceId}`),
      refreshToggle: refreshToggle,
    },
  ];
};
